import { useEffect, useState } from 'react';

import { Box } from '@material-ui/core';
import { SAIDIalogContainer } from '@setvi/shared/components';
import SearchForm from './components/form';
import { SearchFormOptions } from './enums';
import { useMixpanel } from '../../../hooks';

export interface ProductMatchProps {
  options: SearchFormOptions[];
  defaultType?: SearchFormOptions;
  title?: string;
  description?: string;
  handleSearch: (
    type: SearchFormOptions,
    search: {
      value: string;
      [key: string]: string | boolean;
    }
  ) => void;
  onClose?: () => void;
}

export type Rankings = {
  enablePrivateLabelRanking: boolean;
  enableStockProductRanking: boolean;
  enableVendorRanking: boolean;
};

export enum ProductMatchValues {
  Url = 'url',
  Text = 'text',
  Image = 'imageUrl',
  Description = 'description',
  Equipment = 'equipment',
  ProductName = 'productName',
  ManufacturerName = 'manufacturerName',
  ManufacturerSku = 'manufacturerSku'
}

export enum RankingsValues {
  PrivateLabel = 'enablePrivateLabelRanking',
  StockProduct = 'enableStockProductRanking',
  Vendor = 'enableVendorRanking'
}

export const productMatchValues = {
  [ProductMatchValues.Url]: '',
  [ProductMatchValues.Text]: '',
  [ProductMatchValues.Image]: '',
  [ProductMatchValues.Description]: '',
  [ProductMatchValues.Equipment]: '',
  [ProductMatchValues.ProductName]: '',
  [ProductMatchValues.ManufacturerName]: '',
  [ProductMatchValues.ManufacturerSku]: '',
  [RankingsValues.PrivateLabel]: true,
  [RankingsValues.StockProduct]: true,
  [RankingsValues.Vendor]: true
};

const SProductMatch = ({
  options,
  defaultType = SearchFormOptions.url,
  title,
  description,
  handleSearch,
  onClose
}: ProductMatchProps) => {
  const { track } = useMixpanel();

  const [values, setValues] = useState(productMatchValues);
  const [activeType, setActiveType] = useState<SearchFormOptions>(
    defaultType || SearchFormOptions.url
  );

  useEffect(() => {
    track({
      name: 'Page View',
      props: { page: 'ProductMatch', type: activeType }
    });
  }, [track, activeType]);

  return (
    <SAIDIalogContainer
      maxWidth={1135}
      height="fit-content"
      title={title}
      headerDivider={false}
      description={description}>
      <Box mx={4} my={3} display="flex" alignItems="center" overflow="hidden">
        <SearchForm
          expanded
          defaultOption={activeType}
          options={options}
          values={values}
          height="fit-content"
          onSubmit={(aiType, search) => {
            onClose?.();
            handleSearch(aiType, search);
          }}
          onChange={(newValue: { [key: string]: string }) => {
            const key = Object.keys(newValue)?.[0] as SearchFormOptions;
            const newType =
              newValue[key] === ProductMatchValues.Description
                ? SearchFormOptions.image
                : Object.keys(newValue)?.[0];

            setActiveType(newType as SearchFormOptions);
            setValues(prev => ({ ...prev, ...newValue }));
          }}
        />
      </Box>
    </SAIDIalogContainer>
  );
};

export default SProductMatch;
